module.exports = __webpack_public_path__ + "img/d200702b.48b76b33.jpg";